import { cn } from '../../utils/classNames';
import InfoText from '../ui-control/InfoText';

const rowClasses = `flex items-center gap-2`;

const labelClasses = `font-sans text-content text-base 
whitespace-nowrap mb-0 cursor-pointer`;

const switchWrapperClasses = 'relative inline-block w-12.5 h-6.25 cursor-pointer';

const inputClasses = 'opacity-0 w-0 h-0';

const trackBaseClasses = `absolute inset-0 rounded-[calc(var(--spacing)*8.5)] 
transition-colors duration-[400ms]`;

const thumbBaseClasses = `absolute bottom-[calc(var(--spacing)*0.875)] 
left-1 w-4.5 h-4.5 bg-white rounded-full 
shadow transition-transform duration-[400ms]`;

const XCheckbox = ({
  label,
  name,
  checked,
  onChange,
  disabled = false,
  infoText,
  className,
  ...props
}) => {
  return (
    <div className={className}>
      <div className={rowClasses}>
        {label && (
          <label className={labelClasses} htmlFor={name}>
            {label}
          </label>
        )}
        <label className={cn(switchWrapperClasses, disabled && 'cursor-not-allowed')}>
          <input
            type="checkbox"
            id={name}
            name={name}
            checked={checked || false}
            onChange={onChange}
            disabled={disabled}
            className={inputClasses}
            {...props}
          />
          <span className={cn(trackBaseClasses, checked ? 'bg-primary' : 'bg-border')} />
          <span className={cn(thumbBaseClasses, checked && 'translate-x-6')} />
        </label>
      </div>
      {infoText && <InfoText message={infoText} />}
    </div>
  );
};

export default XCheckbox;
